import CurrencyRates from '../../../modules/utilities/containers/currency-rates';

export default {
  path: ':organization/utilities',
  childRoutes: [
    {
      path: 'rates',
      component: CurrencyRates,
      title: 'Currency Rates',
    },
  ],
};
